import React, { useState, useContext } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CustomAlert from "../../shared/CustemAlert";
import HelpContext from "../../shared/context/HelpProvider";
import HelpModal from "../../shared/HelpModal";
import { MdLiveHelp } from "react-icons/md";
import MyJustDate from "../../shared/MyJustDate";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, moamad, eduOptions, hagsha_aharon }) {
  const { setSaeef, setShowHelp } = useContext(HelpContext);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [newEdu, setNewEdu] = useState({
    mosad_name: "",
    education_type: "",
    city: "",
    edu_num: 0,
    end_year: 0,
    subject: "",
    diploma: "",
    moamad: moamad.id,
  });
  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now());

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewEdu((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosPrivate.post(baseURL + "education/", newEdu);
      increment();
      setShowCustomAlert(true);
    } catch (err) {
      // Handle errors
    }
  };

  return (
    <div>
      <HelpModal />
      <center>
        <div className="container">
          <div className="card text-dark bg-light p-3 border">
            {moamad.signature_date ? (
              <h4 style={{ color: "green" }}>
                המעמדות שלך למכרז נחתמה ושוגרה, לא תוכל להוסיף עדכונים.
              </h4>
            ) : (
              <h4 style={{ color: "red" }}>
                <AiOutlineWarning />
                שים לב המועמדות שלך למכרז, עדיין לא נחתמה ולא שוגרה.
                <AiOutlineWarning />
              </h4>
            )}
            <h5
              onClick={() => {
                setSaeef("4-4");
                setShowHelp(true);
              }}
            >
              ההשכלה של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h5>
          </div>
          {!readOnly && (
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="education_type" className="required-label">
                    בחר סוג השכלה:{" "}
                  </label>
                  <select
                    name="education_type"
                    onChange={handleChange}
                    value={newEdu.education_type}
                    required
                  >
                    <option key="0" value="" selected>
                      בחר סוג
                    </option>
                    {eduOptions?.map((a) => (
                      <option key={a[0]} value={a[1]}>
                        {a[1]}
                      </option>
                    ))}
                  </select>
                </div>
                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-cgroup">
                      <label htmlFor="mosad_name" className="required-label">
                        שם מוסד
                      </label>
                      <input
                        type="text"
                        name="mosad_name"
                        className="form-control"
                        id="mosad_name"
                        value={newEdu.mosad_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="city" className="required-label">
                        היישוב של המוסד
                      </label>
                      <input
                        type="text"
                        name="city"
                        className="form-control"
                        id="city"
                        value={newEdu.city}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div className="form-group">
                      <label htmlFor="subject" className="required-label">
                        המקצוע העיקרי
                      </label>
                      <input
                        type="text"
                        name="subject"
                        className="form-control"
                        id="subject"
                        value={newEdu.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={4}>
                    <div className="form-group">
                      <label htmlFor="edu_num" className="required-label">
                        מספר שנות לימוד
                      </label>
                      <input
                        type="number"
                        name="edu_num"
                        className="form-control"
                        id="edu_num"
                        value={newEdu.edu_num}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={4}>
                    <div className="form-group">
                      <label htmlFor="end_year" className="required-label">
                        שנת סיום
                      </label>
                      <input
                        type="number"
                        name="end_year"
                        className="form-control"
                        id="end_year"
                        min="1900"
                        max="2222"
                        value={newEdu.end_year}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={4}>
                    <div className="form-group">
                      <label htmlFor="diploma" className="required-label">
                        התואר או התעודה
                      </label>
                      <input
                        type="text"
                        name="diploma"
                        className="form-control"
                        id="diploma"
                        value={newEdu.diploma}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <button type="submit" className="btn btn-primary">
                  הוסף
                </button>
              </form>
              {showCustomAlert && (
                <div className="alert-max-width">
                  <CustomAlert
                    setShow={setShowCustomAlert}
                    alertHeader="הוספת השכלה למועמד"
                    alertBody="ההשכלה נוספה בהצלחה"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </center>
    </div>
  );
}
